import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";

const initialState = {
  loading: false,
  serviceLoading: false,
  teamMembers: [],
  category: [],
  zoneList: [],
  profile: "",
  profilePerformance: "",
  images: false,
  error: "",
  providerListByPrice: [],
  providerPrice: false,
  tips: [],
  reviewRatingData: false,
  order: [],
  providerServices: [],
  serviceSummary: false,
  dedeclineMessage: false,
  cardData: false,
  serviceAreaWiseZips: "",
  providerReview: null,
  schedule: null,
  monthlyLoader: false,
  monthlySchedule: [],
  bookedLoading: false,
  bookedDetails: null,
  providerTeam: null,
  teamLoader: false,
  teamDetails: null,
  analyticData: false,
};

const url = `${BASE_URL}/worker`;

const token = localStorage.getItem("token");

const config = {
  headers: {
    Authorization: `Token ${token}`,
  },
};

export const fetchTeamMembers = createAsyncThunk(
  "fetch/teamMembers",
  async () => {
    return axios.get(`${url}/`, config).then((response) => response.data);
  }
);
export const fetchServiceAreaWiseZips = createAsyncThunk(
  "fetch/serviceAreaWiseZip",
  async (providerTextId) => {
    return axios
      .get(`${url}/serviceAreaWiseZips/${providerTextId}`, config)
      .then((response) => response.data);
  }
);
export const fetchProviderOrders = createAsyncThunk(
  "fetch/providerOrder",
  async (item) => {
    return axios
      .get(`${url}/orderlist/${item}/`, config)
      .then((response) => response.data);
  }
);

export const fetchProviderReview = createAsyncThunk(
  "fetch/providerReview",
  async (item) => {
    return axios
      .get(`${url}/reviews/${item}`, config)
      .then((response) => response.data);
  }
);

export const fetchProviderServices = createAsyncThunk(
  "fetch/providerServices",
  async (providerTextId) => {
    return axios
      .get(`${url}/serviceList/${providerTextId}`, config)
      .then((response) => response.data);
  }
);

export const fetchProviderPriceListApi = createAsyncThunk(
  "fetch/providerPrice",
  async () => {
    return axios
      .get(`${url}/servicePriceReview`, config)
      .then((response) => response.data);
  }
);
export const fetchReviewRatingManagementApi = createAsyncThunk(
  "fetch/ReviewRatingManagement",
  async () => {
    return axios
      .get(`${url}/ReviewRatingManagement`, config)
      .then((response) => response.data);
  }
);

export const updateReviewRatingManagementApi = createAsyncThunk(
  "update/ReviewRatingManagement",
  async (data) => {
    console.log("in ReviewRatingManagement: ", data);
    return axios
      .post(`${url}/ReviewRatingManagement`, data, config)
      .then((response) => response.data);
  }
);

export const fetchProfile = createAsyncThunk(
  "fetch/profile",
  async (textId) => {
    return axios
      .get(`${url}/profile/${textId}/`, config)
      .then((response) => response.data);
  }
);

export const fetchWorkerDocumentsView = createAsyncThunk(
  "fetch/WorkerDocumentsView",
  async (textId) => {
    return axios
      .get(`${url}/profile/${textId}/WorkerDocumentsView/`, config)
      .then((response) => response.data);
  }
);
export const fetchCategoryServiceWithAreas = createAsyncThunk(
  "fetch/CategoryServiceAreas",
  async (textId) => {
    return axios
      .get(`${url}/PendingServiceWithAreas/${textId}/`, config)
      .then((response) => response.data);
  }
);
export const fetchServicePriceListApi = createAsyncThunk(
  "fetch/servicePriceList",
  async (data) => {
    return axios
      .get(
        `${url}/servicePriceReviewDetails/${data.workerTextId}/${data.serviceTextId}/${data.categoryTextId}`,
        config
      )
      .then((response) => response.data);
  }
);
export const fetchProviderTipManagementApi = createAsyncThunk(
  "fetch/ProviderTipManagement",
  async () => {
    return axios
      .get(`${url}/providerTipManagement`, config)
      .then((response) => response.data);
  }
);
// export const exportOrderApi = createAsyncThunk(
//     'fetch/tips', async (formData) => {
//         return axios
//             .post(`${url}/providerTipManagement`,formData, config)
//             .then((response) => response.data)
//     }
// )

export const changeTeamMemberStatus = createAsyncThunk(
  "update/teamMemberStatus",
  async (data) => {
    return (
      axios
        // .put(`${url}/status/${formData.textId}/`, {"status": formData.status}, config)
        .put(`${url}/status/${data.textId}/`, data, config)
        .then((response) => response.data)
    );
  }
);

export const workerDataValidationNoticePost = createAsyncThunk(
  "create/workerDataValidationCheck",
  async (formData) => {
    console.log("------------------", formData);
    return axios
      .put(
        `${url}/workerDataValidationCheck/${formData.workerTextId}/`,
        formData,
        config
      )
      .then((response) => response.data);
  }
);
export const zipCodeRejectedPost = createAsyncThunk(
  "create/DataValidationNotice",
  async (formData) => {
    // console.log(formData)
    return axios
      .put(
        `${url}/zipCodeAcceptReject/${formData.workerTextId}/`,
        formData,
        config
      )
      .then((response) => {
        response.data.localData = formData.localData;
        return response.data;
      });
  }
);
export const workerPriceDeclinePostApi = createAsyncThunk(
  "create/PriceDecline",
  async (formData) => {
    console.log(formData);
    return axios
      .post(
        `${url}/servicePriceReviewDetails/${formData.workerTextId}/${formData.serviceTextId}/${formData.categoryTextId}`,
        formData,
        config
      )
      .then((response) => {
        response.data.localData = formData.localData;
        response.data.priceRejectedNote = formData.priceRejectedNote;
        return response.data;
      });
  }
);
export const workerPriceDeclineUpdate = createAsyncThunk(
  "create/PriceDeclineUpdate",
  async (formData) => {
    console.log(formData);
    // rejectedServiceId
    // rejectedServiceId
    return axios
      .put(
        `${url}/priceRejectedContentUpdate/${formData.rejectedServiceId}/`,
        formData,
        config
      )
      .then((response) => {
        response.data.priceRejectedNote = formData.priceRejectedNote;
        return response.data;
      });
  }
);

export const fetchSchedule = createAsyncThunk(
  "fetch/schedule",
  async ({ providerTextId, reqDate }) => {
    return axios
      .get(`${url}/scheduleView/${providerTextId}/?q=${reqDate}`, config)
      .then((response) => response.data);
  }
);

export const fetchMonthlySchedule = createAsyncThunk(
  "fetch/MonthlySchedule",
  async ({ providerTextId, body }) => {
    console.log("in ReviewRatingManagement: ", body);
    return axios
      .post(`${url}/scheduleView/${providerTextId}/`, body, config)
      .then((response) => response.data);
  }
);

export const fetchBookedDtls = createAsyncThunk(
  "fetch/bookedDtls",
  async (bodyData) => {
    return axios
      .get(
        `${url}/scheduleBookedDetails/${bodyData.workerTextId}/?sheduleDateTime=${bodyData.sheduleDateTime}`,
        config
      )
      .then((response) => response.data);
  }
);

export const fetchTeam = createAsyncThunk(
  "fetch/team",
  async (workerTextId) => {
    return axios
      .get(`${url}/teamMemberList/${workerTextId}`, config)
      .then((response) => response.data);
  }
);

export const fetchPerformanceAnalytics = createAsyncThunk(
  "fetch/performanceAnalytics",
  async (workerTextId) => {
    // const curl = `${BASE_URL}/performance-analytics/${workerTextId}`;
    return axios
      .get(`${url}/team/performance-analytics/${workerTextId}`, config)
      .then((response) => response.data);
  }
);

export const fetchTeamDetails = createAsyncThunk(
  "fetch/teamDetails",
  async (memberTextId) => {
    return axios
      .get(`${url}/teamMemberDetails/${memberTextId}`, config)
      .then((response) => response.data);
  }
);

const teamMembersSlice = createSlice({
  name: "teamMembers",
  initialState,
  reducers: {
    zipCodeList(state, action) {
      let zipRow = action.payload.zipRow;
      let zoneRow = action.payload.zoneRow;
      // state.subData[rootIndex].controls[childIndex][name] = (value);
      state.zoneList[zoneRow].zipcode[zipRow]["status"] = action.payload.status;
    },
    workerStatusUpdate(state, action) {
      state.profile.status = action.payload.status;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTeamMembers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTeamMembers.fulfilled, (state, action) => {
      state.loading = false;
      state.teamMembers = action.payload.worker_list;
      state.cardData = action.payload.provider_statistic;
      state.error = "";
      console.log(action.payload);
    });
    builder.addCase(fetchTeamMembers.rejected, (state, action) => {
      state.loading = false;
      state.teamMembers = [];
      state.error = action.error;
    });

    builder.addCase(fetchProfile.pending, (state) => {
      state.loading = true;
      state.profile = "";
      state.profilePerformance = "";
    });

    builder.addCase(fetchProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.profile = action.payload.provider_data;
      state.profilePerformance = action.payload.provider_performance;

      state.error = "";
    });

    builder.addCase(fetchProfile.rejected, (state, action) => {
      state.loading = false;
      state.profile = [];
      state.profilePerformance = "";
      state.error = action.error;
    });

    builder.addCase(fetchWorkerDocumentsView.pending, (state) => {
      state.loading = true;
      state.images = false;
    });
    builder.addCase(fetchWorkerDocumentsView.fulfilled, (state, action) => {
      state.loading = false;
      state.images = action.payload;
      state.error = "";
    });
    builder.addCase(fetchWorkerDocumentsView.rejected, (state, action) => {
      state.loading = false;
      state.images = [];
      state.error = action.error;
    });

    builder.addCase(fetchServiceAreaWiseZips.pending, (state) => {
      // state.loading = false;
    });
    builder.addCase(fetchServiceAreaWiseZips.fulfilled, (state, action) => {
      //state.loading = false;
      state.serviceAreaWiseZips = action.payload;
      state.error = "";
    });
    builder.addCase(fetchServiceAreaWiseZips.rejected, (state, action) => {
      // state.loading = false;
      state.error = action.error;
    });

    //===========================
    builder.addCase(fetchSchedule.pending, (state) => {});
    builder.addCase(fetchSchedule.fulfilled, (state, action) => {
      state.schedule = action.payload;
      state.error = "";
    });
    builder.addCase(fetchSchedule.rejected, (state, action) => {
      state.error = action.error;
    });
    //===========================

    //===========================
    builder.addCase(fetchMonthlySchedule.pending, (state) => {
      state.monthlyLoader = true;
    });
    builder.addCase(fetchMonthlySchedule.fulfilled, (state, action) => {
      state.monthlySchedule = action.payload;
      state.error = "";
      state.monthlyLoader = false;
    });
    builder.addCase(fetchMonthlySchedule.rejected, (state, action) => {
      state.error = action.error;
      state.monthlyLoader = false;
    });
    //===========================

    builder.addCase(fetchCategoryServiceWithAreas.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchCategoryServiceWithAreas.fulfilled,
      (state, action) => {
        state.loading = false;
        // state.profile = action.payload;
        state.category = action.payload.category_list;
        state.zoneList = action.payload.zone_list;

        state.error = "";
      }
    );
    builder.addCase(fetchCategoryServiceWithAreas.rejected, (state, action) => {
      state.loading = false;
      state.category = [];
      state.zoneList = [];
      state.error = action.error;
    });

    builder.addCase(fetchProviderOrders.pending, (state) => {
      // state.loading = true;
    });
    builder.addCase(fetchProviderOrders.fulfilled, (state, action) => {
      //  state.loading = false;
      if (action.payload.order_list) {
        state.order = action.payload.order_list;
      }

      state.error = "";
    });
    builder.addCase(fetchProviderOrders.rejected, (state, action) => {
      // state.loading = false;
      // state.error = action.error;
    });

    builder.addCase(fetchProviderReview.pending, (state) => {});
    builder.addCase(fetchProviderReview.fulfilled, (state, action) => {
      state.providerReview = action.payload;
      state.error = "";
    });
    builder.addCase(fetchProviderReview.rejected, (state, action) => {
      state.error = action.error;
    });

    builder.addCase(fetchProviderServices.pending, (state) => {
      state.serviceLoading = true;
    });
    builder.addCase(fetchProviderServices.fulfilled, (state, action) => {
      state.serviceLoading = false;
      state.providerServices = action.payload.serviceArray;
      state.error = "";
    });
    builder.addCase(fetchProviderServices.rejected, (state, action) => {
      state.serviceLoading = false;
      state.error = action.error;
    });

    builder.addCase(fetchServicePriceListApi.pending, (state) => {
      state.loading = true;
      state.providerPrice = false;
      state.dedeclineMessage = false;
    });
    builder.addCase(fetchServicePriceListApi.fulfilled, (state, action) => {
      state.loading = false;
      state.providerPrice = action.payload.results;
      if (action.payload.results.pricingStatus === "Rejected") {
        state.dedeclineMessage = action.payload.results.rejected_contents;
      }
      state.error = "";
    });
    builder.addCase(fetchServicePriceListApi.rejected, (state, action) => {
      state.loading = false;
      state.providerPrice = false;
      state.error = action.error;
    });
    builder.addCase(fetchProviderTipManagementApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchProviderTipManagementApi.fulfilled,
      (state, action) => {
        state.loading = false;
        state.tips = action.payload.tip_list;
        // console.log(action.payload)
        state.error = "";
      }
    );
    builder.addCase(fetchProviderTipManagementApi.rejected, (state, action) => {
      state.loading = false;
      state.tips = [];
      state.error = action.error;
    });

    builder.addCase(fetchReviewRatingManagementApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchReviewRatingManagementApi.fulfilled,
      (state, action) => {
        state.loading = false;
        state.reviewRatingData = action.payload.review_data;
        state.error = "";
        // console.log(action.payload)
      }
    );
    builder.addCase(
      fetchReviewRatingManagementApi.rejected,
      (state, action) => {
        state.loading = false;
        state.providerListByPrice = [];
        state.reviewRatingData = false;
        state.error = action.error;
      }
    );

    builder.addCase(updateReviewRatingManagementApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      updateReviewRatingManagementApi.fulfilled,
      (state, action) => {
        state.loading = false;
        state.reviewRatingData = action.payload.review_data;
        state.error = "";
      }
    );
    builder.addCase(
      updateReviewRatingManagementApi.rejected,
      (state, action) => {
        state.loading = false;
        state.reviewRatingData = false;
        state.error = action.error;
      }
    );

    builder.addCase(fetchProviderPriceListApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProviderPriceListApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.service_list) {
        state.providerListByPrice = action.payload.service_list;
      }
      if (action.payload.serviceSummary) {
        state.serviceSummary = action.payload.serviceSummary;
      }
      // state.providerListByPrice = action.payload.service_list;
      state.error = "";
      console.log(action.payload);
    });
    builder.addCase(fetchProviderPriceListApi.rejected, (state, action) => {
      state.loading = false;
      state.providerListByPrice = [];
      state.error = action.error;
    });

    builder.addCase(changeTeamMemberStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(changeTeamMemberStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.profile.status = action.payload.status;
      state.error = "";
      console.log("___profile.status____", action.payload);
    });
    builder.addCase(changeTeamMemberStatus.rejected, (state, action) => {
      state.loading = false;
      // state.providerListByPrice = [];
      state.error = action.error;
    });

    builder.addCase(workerPriceDeclinePostApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workerPriceDeclinePostApi.fulfilled, (state, action) => {
      state.loading = false;
      // state.dedeclineMessage = action.payload;
      state.error = "";
      console.log(action.payload);
    });
    builder.addCase(workerPriceDeclinePostApi.rejected, (state, action) => {
      state.loading = false;
      // state.providerListByPrice = [];
      state.error = action.error;
    });

    builder.addCase(workerPriceDeclineUpdate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workerPriceDeclineUpdate.fulfilled, (state, action) => {
      state.loading = false;
      state.dedeclineMessage.priceRejectedNote =
        action.payload.priceRejectedNote;
      state.error = "";
      console.log(action.payload);
    });
    builder.addCase(workerPriceDeclineUpdate.rejected, (state, action) => {
      state.loading = false;
      // state.providerListByPrice = [];
      state.error = action.error;
    });

    // =================Booked details=============
    builder.addCase(fetchBookedDtls.pending, (state) => {
      state.bookedLoading = true;
    });
    builder.addCase(fetchBookedDtls.fulfilled, (state, action) => {
      state.bookedLoading = false;
      state.bookedDetails = action.payload;
      state.error = "";
    });
    builder.addCase(fetchBookedDtls.rejected, (state, action) => {
      state.bookedLoading = false;
      state.error = action.error;
    });

    // =================Fetech team=============
    builder.addCase(fetchTeam.pending, (state) => {
      state.teamLoader = true;
    });
    builder.addCase(fetchTeam.fulfilled, (state, action) => {
      state.teamLoader = false;
      state.providerTeam = action.payload;
      state.error = "";
    });
    builder.addCase(fetchTeam.rejected, (state, action) => {
      state.teamLoader = false;
      state.error = action.error;
    });

    
    builder.addCase(fetchPerformanceAnalytics.fulfilled, (state, action) => {
       
      state.analyticData = action.payload.data;
   
    });
    builder.addCase(fetchPerformanceAnalytics.rejected, (state, action) => {
      state.teamLoader = false;
      state.error = action.error;
    });

    // ================Fetech team details=============
    builder.addCase(fetchTeamDetails.pending, (state) => {
      state.teamLoader = true;
    });
    builder.addCase(fetchTeamDetails.fulfilled, (state, action) => {
      state.teamLoader = false;
      state.teamDetails = action.payload.teamMemberDetails;
      state.error = "";
    });
    builder.addCase(fetchTeamDetails.rejected, (state, action) => {
      state.teamLoader = false;
      state.error = action.error;
    });
  },
});

export const { zipCodeList, workerStatusUpdate } = teamMembersSlice.actions;
export default teamMembersSlice.reducer;
